import { Box, SimpleGrid, useRadio, useRadioGroup, UseRadioProps } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

type RadioButtonProps = PropsWithChildren & UseRadioProps;

function RadioButton({ children, ...props}: RadioButtonProps) {
  const { getInputProps, getRadioProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getRadioProps();

  return (
    <Box as="label">
      <input {...input} />
      <Box
        {...checkbox}
        h="30px"
        cursor="pointer"
        borderRadius="6px"
        padding="4px 2px"
        textAlign="center"
        fontSize="14px"
        fontWeight="medium"
        letterSpacing="-0.084px"
        color="#868C98"
        _checked={{
          bgColor: 'white',
          boxShadow: '0px 6px 10px 0px rgba(27, 28, 29, 0.06), 0px 2px 4px 0px rgba(27, 28, 29, 0.02)',
          color: '#0A0D14'
        }}
        _focus={{
          //boxShadow: 'outline',
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export interface RadioButtonValue {
  label: string;
  value: string
}

export interface CustomRadioGroupProps {
  name: string;
  defaultValue?: string;
  options: RadioButtonValue[];
  onChange?: (value: string) => void;
}

export default function CustomRadioGroup({ name, defaultValue, options, onChange }: CustomRadioGroupProps) {

  const { getRootProps, getRadioProps } = useRadioGroup({
    name,
    defaultValue: defaultValue ?? options?.[0]?.value,
    onChange
  });

  const group = getRootProps();

  return (
    <SimpleGrid
      columns={options.length}
      borderRadius="10px"
      bgColor="rgba(226, 228, 233, 0.50)"
      padding="4px"
      {...group}

    >
      {options.map((option) => {
        const radio = getRadioProps({ value: option.value })
        return (
          <RadioButton 
            key={option.value} 
            {...radio}
          >
            { option.label }
          </RadioButton>
        )
      })}
    </SimpleGrid>
  )
}
